<template>
    <div>
    <b-tabs class="accounts-show-tab apprentice-tab">
        <b-tab :title="$t('accounts.main_groups')" class="apprentice-simple-card">
            <design-2021-apprentice-data-table
                :items="lasMainGroupsIn"
                :fields="fields">
                <template v-slot:cell(actions)="data">
                    <div class="actions">
                        <b-button
                            class="btn-open"
                            variant="primary-icon-only"
                            @click="openMainGroupModal(data.item)"
                            :v-b-tooltip="$t('common.edit')"
                        ></b-button>
                    </div>
                </template>
            </design-2021-apprentice-data-table>
        </b-tab>
        <b-tab :title="$t('accounts.groups')">
            <design-2021-apprentice-data-table
                :items="lasGroupsIn"
                :fields="fields">
                <template v-slot:cell(actions)="data">
                    <div class="actions">
                        <b-button
                            class="btn-open"
                            variant="primary-icon-only"
                            @click="openGroupModal(data.item)"
                            :v-b-tooltip="$t('common.edit')"
                        ></b-button>
                    </div>
                </template>
            </design-2021-apprentice-data-table>
        </b-tab>
    </b-tabs>
        <design-2021-las-main-group-modal-component
            ref="main-group-modal"
        ></design-2021-las-main-group-modal-component>
        <design-2021-las-group-modal-component
            ref="group-modal"
        ></design-2021-las-group-modal-component>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-las-groups-component',
        props: {
            lasGroupsIn: {
                type: Array
            },
            lasMainGroupsIn: {
                type: Array
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: 'name',
                        label: this.$t('common.name'),
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        label: this.$t('common.actions'),
                        sortable: false,
                    }
                ],
            };
        },
        methods: {
            openMainGroupModal(lasMainGroup) {
                this.$refs['main-group-modal'].show(lasMainGroup)
            },

            openGroupModal(lasGroup) {
                this.$refs['group-modal'].show(lasGroup)
            }
        },
    };
</script>

<style scoped lang="scss">

</style>